<app-page [size]="PageSize.SINGLE" [maxWidth]="'max-w-[1100px]'" [marginTop]="'mt-1 sm:mt-2'">
  @if (wizardType === WizardType.EWE_BY_EMAIL) {
    <!-- EWE BY EMAIL WIZARD -->
    <div
      class="p-0.5 sm:p-2 relative"
    >
    @if (showActionButtons()) {
      <app-wizard-action-buttons
        [customerWizardResponse]="customerWizardResponse"
        [showActionButtons]="showActionButtons()"
        [currentStep]="currentStep"
        [brand]="brand"
        [wizardType]="WizardType.EWE_BY_EMAIL"
        [skipAllInProgress]="skipAllInProgress"
        (nextStep)="nextStep()"
        (previousStep)="previousStep()"
        (accept)="onAccept($event)"
        (skip)="onSkip()"
        class="sticky z-10 top-0 w-full"
      />
    }
    <div class="w-full">
      @switch (currentStep) {
        @case (0) {
          <app-wizard-start-page
            [brand]="brand"
            (nextStep)="nextStep()"
          />
        }
        @case (1) {
          <app-wizard-customer-data
            [customerWizardResponse]="customerWizardResponse"
            [brand]="brand"
            [legalEntity]="legalEntity"
            (nextStep)="nextStep()"
          />
        }
        @case (2) {
          <app-wizard-communication
            [brand]="brand"
            [customerWizardResponse]="customerWizardResponse"
          />
        }
        @case (3) {
          <app-wizard-profiling
            [wizardType]="WizardType.EWE_BY_EMAIL"
            [description]="getContactEvent('PROFILING').customerDescription"
          />
        }
        @case (4) {
          <app-wizard-data-sharing
            [wizardType]="WizardType.EWE_BY_EMAIL"
            [description]="getContactEvent('DATA_SHARING').customerDescription"
          />
        }
        @case (5) {
          <app-wizard-mail-summary
            [brand]="brand"
            [confirmWithMailInProgress]="confirmWithMailInProgress"
            [confirmWithoutMailInProgress]="confirmWithoutMailInProgress"
            (sendMailSummary)="onAccept($event)"
            (withoutMailSummary)="onSkip()"
          />
        }
        @case (6) {
          <app-wizard-end-page
            [dshImg]="dshImg"
            [noConfirmations]="noConfirmations"
          />
        }
      }
    </div>
    @if (showActionButtons() || currentStep === 1) {
      <div class="flex flex-col mt-4 justify-center items-center w-full pointer-events-none text-xs text-lighterText">
        <span>Version: {{ customerWizardResponse.currentConsentVersion }}</span>
        <span>Händler-ID: {{ customerWizardResponse.dealer.dealerNumber }}-{{ customerWizardResponse.customerNumber }}</span>
        <span>TEC-ID: {{ customerWizardResponse.tecCustomerId }}</span>
      </div>
    }
  </div>
  } @else if (wizardType === WizardType.DIGITAL_SIGNATURE) {
    <!-- DIGITAL SIGNATURE WIZARD -->
    <div class="flex flex-col min-h-0"
         [ngClass]="{
         'h-[calc(100dvh-80px)]': currentStep !== 5,
         'landscape:max-h-[600px]': currentStep !== 5,
         'md:portrait:max-h-[800px]': currentStep !== 5
         }"
    >
      <div class="flex-1 overflow-y-auto flex justify-center items-start">
        <div class="origin-top w-full px-1">
          <div class="w-full flex-grow">
            @switch (currentStep) {
              @case (0) {
                <app-wizard-dig-sig-customer-data
                  [customerWizardResponse]="customerWizardResponse"
                  [brand]="brand"
                  [legalEntity]="legalEntity"
                  (nextStep)="nextStep()"
                />
              }
              @case (1) {
                <app-wizard-dig-sig-communication
                  [brand]="brand"
                  [customerWizardResponse]="customerWizardResponse"
                />
              }
              @case (2) {
                <app-wizard-profiling
                  [wizardType]="WizardType.DIGITAL_SIGNATURE"
                  [description]="getContactEvent('PROFILING').customerDescription"
                />
              }
              @case (3) {
                <app-wizard-data-sharing
                  [wizardType]="WizardType.DIGITAL_SIGNATURE"
                  [description]="getContactEvent('DATA_SHARING').customerDescription"
                />
              }
              @case (4) {
                <app-wizard-mail-summary
                  [brand]="brand"
                  [confirmWithMailInProgress]="confirmWithMailInProgress"
                  [confirmWithoutMailInProgress]="confirmWithoutMailInProgress"
                  (sendMailSummary)="onAccept($event)"
                  (withoutMailSummary)="onSkip()"
                />
              }
              @case (5) {
                <app-wizard-end-page
                  [dshImg]="dshImg"
                  [noDigitalSignatures]="noDigitalSignatures"
                />
              }
            }
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <app-wizard-action-buttons
        [customerWizardResponse]="customerWizardResponse"
        [showActionButtons]="showActionButtons()"
        [currentStep]="currentStep"
        [brand]="brand"
        [wizardType]="WizardType.DIGITAL_SIGNATURE"
        [existingSignature]="signatures ? signatures[currentStep] : null"
        [skipAllInProgress]="skipAllInProgress"
        (nextStep)="nextStep()"
        (previousStep)="previousStep()"
        (accept)="onAccept($event)"
        (skip)="onSkip()"
        class="w-full"
      />
    </div>
  }
</app-page>
